import { useMemo } from 'react'
import { defineMessage, useIntl } from 'react-intl'

const experienceNaturalLanguageSearchExamples = [
  defineMessage({
    id: 'HVa4m6v3LsUIuVeNFMpl',
    defaultMessage: 'Whale watching in New South Wales',
    description: 'Example experience used in the rotating natural-language search placeholder',
  }),
  defineMessage({
    id: '62JbxayOo1rdn9aCA22R',
    defaultMessage: 'Hot air balloon in Australia',
    description: 'Example experience used in the rotating natural-language search placeholder',
  }),
  defineMessage({
    id: 'FdahrdSJTp0fRNRr-4gA',
    defaultMessage: 'Street food in Bangkok',
    description: 'Example experience used in the rotating natural-language search placeholder',
  }),
]

function useExperienceSearchLabels() {
  const intl = useIntl()
  const naturalLanguageSearchExamples = useMemo(() =>
    experienceNaturalLanguageSearchExamples.map(example => intl.formatMessage(example)),
  [intl],
  )

  return {
    locationLabel: intl.formatMessage({
      id: 'fAbXtlG191rscTiT-hGp',
      defaultMessage: 'Destination',
      description: 'Label for experience search location input in the search interface',
    }),
    locationPlaceholder: intl.formatMessage({
      id: 'Nxik7RnvAls2bF4fcO4Y',
      defaultMessage: 'Search by destination',
      description: 'Placeholder text for experience search location input',
    }),
    naturalLanguageLocationLabel: intl.formatMessage({
      id: 'eh6PvDE88PQC-5v7ye8t',
      defaultMessage: 'Search Destinations or Experiences',
      description: 'Label for the experience natural-language destination and activity search input',
    }),
    naturalLanguageSearchExamples,
    searchLabel: intl.formatMessage({
      id: 'mgeoBdt41Hyg_SXlYI9G',
      defaultMessage: 'Search',
      description: 'Button text to submit experience search form in the search interface',
    }),
    whenLabel: intl.formatMessage({
      id: 'eoEjsv0FnQveDShwrthu',
      defaultMessage: 'When',
      description: 'Form field label for the date field when anytime is selected',
    }),
    anytimePlaceholder: intl.formatMessage({
      id: 'RigImioe5lWt2RsFEZL9',
      defaultMessage: 'Anytime',
      description: 'Placeholder for date field indicating any date is acceptable',
    }),
    clearAllLabel: intl.formatMessage({
      id: 'MHb8lQ7Liy1ixnu8EKVa',
      defaultMessage: 'Clear all',
      description: 'Action button label to clear all applied flight filters',
    }),
    todayLabel: intl.formatMessage({
      id: 'AHwE-JrMwGjmJsScIJJ8',
      defaultMessage: 'Today',
      description: 'Quick date chip label for today in experiences date dropdown',
    }),
    tomorrowLabel: intl.formatMessage({
      id: 'IdXFYyn3Ih3xMMiAMWJ1',
      defaultMessage: 'Tomorrow',
      description: 'Quick date chip label for tomorrow in experiences date dropdown',
    }),
    thisWeekendLabel: intl.formatMessage({
      id: 'AzBOEGuHa1-HP1JDqYkD',
      defaultMessage: 'This weekend',
      description: 'Quick date chip label for this weekend in experiences date dropdown',
    }),
    searchInLabel: intl.formatMessage({
      id: 'lipSaV1MLwgF5JI-gKI1',
      defaultMessage: 'Search experiences in',
      description: 'Mobile search bar placeholder text on experiences landing page',
    }),
    searchTransfersInLabel: intl.formatMessage({
      id: 'vhwqRHO3IWZwsBfVKiig',
      defaultMessage: 'Search transfers in',
      description: 'Mobile search bar placeholder text on transfers landing page',
    }),
  }
}

export default useExperienceSearchLabels
